module.exports = __webpack_public_path__ + "static/media/PanAsian.0b5e1f57.jpg";